import { useState } from 'react';

import { Button } from '../ui/Button';

type CodeBlockProps = {
    code: string;
    /** Short label above the block, e.g. curl, JavaScript. */
    label?: string;
};

export function CodeBlock({ code, label }: CodeBlockProps) {
    const [copied, setCopied] = useState(false);

    return (
        <div>
            {label ? <p className="eyebrow mb-2 text-text-muted">{label}</p> : null}
            <pre className="overflow-x-auto whitespace-pre-wrap break-all rounded-md border border-border bg-bg-sunk p-4 font-mono text-xs leading-relaxed text-text sm:text-sm">
                {code}
            </pre>
            <div className="mt-3">
                <Button
                    size="sm"
                    variant="secondary"
                    onClick={() => {
                        void navigator.clipboard.writeText(code).then(() => {
                            setCopied(true);
                            window.setTimeout(() => setCopied(false), 2000);
                        });
                    }}
                >
                    {copied ? 'Copied' : 'Copy'}
                </Button>
            </div>
        </div>
    );
}
